import React from 'react';
import { Route } from 'react-router-dom';
import { SignIn } from '../components/SignIn';
import { WellStreamAPI } from './WellStreamAPI';

export const PrivateRoute = ({ component: Component, ...rest }) => {

    if (WellStreamAPI.IsAuthenticated()) {

        return (
            <Route {...rest} render={props => (
                <Component {...props} />
            )} />);
    } else {

        return (
            <Route {...rest} render={() => (
                <SignIn />
            )} />);
    }
};